import Login from '../../components/auth/login.vue';
import ResetEmail from '../../components/auth/send-reset-email.vue';
import ResetPassword from '../../components/auth/reset-password.vue';
import SignupComplete from '../../components/onboarding/complete.vue';

export default {
    path: '/account/',
    component: {
        render (c) {
            return c('router-view')
        }
    },
    redirect: 'account/login',
    children: [
        {
            path: 'login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false,
                headerStyle:'hidden',
                hideFooter: true,
            }
        },
        {
            path: 'send-reset-email',
            component: ResetEmail,
            meta: {
                requiresAuth: false,
                headerStyle:'hidden',
                hideFooter: true,
            }
        },
        {
            path: 'reset-password',
            component: ResetPassword,
            meta: {
                requiresAuth: false,
                headerStyle:'hidden',
                hideFooter: true,
            }
        },
        {
            path: 'complete',
            component: SignupComplete,
            meta: {
                headerStyle: 'hidden',
                requiresAuth: false,
                hideFooter: true,
            },
        }
    ]
};
